export enum AppMode {
  Public,
  Private
}
// Maps to the following from Internal App Collections: Vertical AppGrid, Tile Carousel, Horizontal AppGrid, Banner
export enum AppCollectionStyles {
  VerticalGrid = 'VERTICAL_GRID',
  ScrollTile = 'SCROLL_TILE',
  ScrollGridTile = 'SCROLL_GRID_TILE',
  ScrollHeroBanner = 'SCROLL_HERO_BANNER',
}

export enum AppCollectionGroup {
  Customer = 'CUSTOMER',
  Employee = 'EMPLOYEE',
  EssentialTool = 'ESSENTIAL_TOOL',
}

export enum AppCollectionScenarios {
  AppMarket = 'APP_MARKET',
  AppDetails = 'APP_DETAIL'
}

export enum ServerFeatures {
  RatingsAndReviews = 'ENABLE_RATINGS_AND_REVIEWS',
  DeveloperRatingsAndReviews = 'ENABLE_DEVELOPER_RATINGS_AND_REVIEWS',
  Flex = 'BAYLEAF_RELEASED',
  Station2018 = 'GOLDENOAK_RELEASED',
  StationSolo = 'GOLDENACORN_RELEASED',
  Mini2 = 'KNOTTYPINE_RELEASED',
  StationDuo = 'GMC_RELEASED',
  Flex2 = 'BAMBOOLEAF_RELEASED',
  Mini3 = 'MAPLETHREE_RELEASED',
  Flex3 = 'FICUSTREE_RELEASED',
  StationSoloInternational = 'SILVERACORN_RELEASED',
  StationDuo2 = 'HOLLOWMAPLE_RELEASED',
  KDS = 'KEYLIME_RELEASED',
  FLEX4 = 'FIGTREE_RELEASED',
  FLEX4P = 'FIGPIE_RELEASED',
  KDS_XL = 'KEYLIMEPIE_RELEASED',
  KIOSK = 'SUGARMAPLE_RELEASED',
  COMPACT = 'PINETREE_RELEASED',
  COMPANION = 'PINETREESEMI_RELEASED'
}

export type ServerFeatureType = typeof ServerFeatures[keyof typeof ServerFeatures];

export enum AppMarketPermissions {
  Access = "_ACCESS",
  AccessServicePlans = "ACCESS_SERVICE_PLANS",
  InstallUninstallApps = "INSTALL_UNINSTALL_APPS"
}
